export const AUTH_PROVIDER_PROPS = {
    authority: process.env.REACT_APP_AUTH_BASE_URL,
    client_id: process.env.REACT_APP_INTERNAL_DIRECTORY_KEY,
    client_secret: process.env.REACT_APP_BASE_SECRET,
    redirect_uri: process.env.REACT_APP_BASE_URL,
    silent_redirect_uri: process.env.REACT_APP_BASE_URL,
    response_type: "token",
    scope: "profile_email",
    metadata: {
      authorization_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/authorize`,
      token_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/token`,
      userinfo_endpoint: `${process.env.REACT_APP_AUTH_BASE_URL}/userinfo`,
    //   end_session_endpoint: `${process.env.REACT_APP_BASE_URL}`,
    },
    loadUserInfo: false,
    autoSignIn: false,
  };

export const AZURE_AUTH_CONFIG = {
  clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
  authority: process.env.REACT_APP_AZURE_AD_AUTHORITY_URL,
  redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI,
  sharePointSiteUrl: process.env.REACT_APP_AZURE_SHAREPOINT_SITE_URL,
};
